module.exports = __webpack_public_path__ + "static/img/footer.ae4d8ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeimg/footer.png
// module id = y6fn
// module chunks = 1